import { useState, useEffect, useCallback } from 'react'

import api from 'api'

const useSkus = ({
  wrapErrorHandler,
  sortKey,
  categoryId,
  titleLike,
  merchantId,
  limit,
}) => {
  const [loading, setLoading] = useState(true)
  const [cursor, setCursor] = useState(null)
  const [hasMore, setHasMore] = useState(false)
  const [dataSource, setDataSource] = useState([])

  const loadData = useCallback(
    async (originData, params) => {
      setLoading(true)
      await wrapErrorHandler(async () => {
        const { data } = await api.getSkus({
          ...params,
          sortKey,
          categoryId,
          titleLike,
          merchantId,
          limit: limit || 6,
        })
        setDataSource(originData.concat(data.skus))
        setCursor(data.cursor)
        setHasMore(data.hasMore)
      })
      setLoading(false)
    },
    [categoryId, limit, sortKey, titleLike, merchantId, wrapErrorHandler]
  )

  useEffect(() => {
    loadData([])
  }, [loadData])

  const loadMore = useCallback(async () => {
    if (loading) {
      return
    }

    if (!hasMore) {
      return
    }

    setLoading(true)
    loadData(dataSource, { from: cursor })
  }, [cursor, dataSource, hasMore, loadData, loading])

  return {
    dataSource,
    hasMore,
    loadMore,
    showLoadingPlaceholder: dataSource.length === 0 && loading,
    showEmptyPlaceholder: dataSource.length === 0 && !loading,
  }
}

export default useSkus
